import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_item_to_item_addon_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_type: fromDatatype.VarcharDatatypeInterface;
  main_product_fi_item_uom: fromDatatype.VarcharDatatypeInterface;
  deal_start_date: fromDatatype.TimestampTzDatatypeInterface;
  deal_end_date: fromDatatype.TimestampTzDatatypeInterface;
  addon_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_type: fromDatatype.VarcharDatatypeInterface;
  addon_fi_item_uom: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  quantity_limit: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_item_to_item_addon_link_RowClass implements bl_fi_item_to_item_addon_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  main_product_fi_item_type: fromDatatype.VarcharDatatypeInterface;
  main_product_fi_item_uom: fromDatatype.VarcharDatatypeInterface;
  deal_start_date: fromDatatype.TimestampTzDatatypeInterface;
  deal_end_date: fromDatatype.TimestampTzDatatypeInterface;
  addon_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_type: fromDatatype.VarcharDatatypeInterface;
  addon_fi_item_uom: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  quantity_limit: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
}
